export const OUTPUT_FILENAME = "gokko-live.png";

// 共有シートのキャンセルは失敗ではないが「共有した」とも言えないため、
// 成功・キャンセル・失敗を呼び出し側が区別できるようにする
export type ShareResult = "shared" | "cancelled" | "failed";

function toFile(blob: Blob): File {
  return new File([blob], OUTPUT_FILENAME, { type: "image/png" });
}

// OS 共有シート（ファイル付き共有）が使える環境かの機能検出。
// 非対応環境では共有ボタン自体を出さない（ダウンロードのみ）
export function canShareFile(blob: Blob): boolean {
  if (typeof navigator.canShare !== "function" || typeof navigator.share !== "function") {
    return false;
  }
  try {
    return navigator.canShare({ files: [toFile(blob)] });
  } catch {
    return false;
  }
}

// モバイルブラウザの共有はユーザー操作直後の呼び出しが必須のため、
// Blob は事前生成済みのものを受け取り、タップハンドラから同期的に呼ぶこと
export async function shareFile(blob: Blob): Promise<ShareResult> {
  try {
    await navigator.share({ files: [toFile(blob)] });
    return "shared";
  } catch (e) {
    if (e instanceof DOMException && e.name === "AbortError") return "cancelled";
    return "failed";
  }
}

export function downloadBlob(blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = OUTPUT_FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // 端末によっては即時 revoke でダウンロードが失敗するため遅延させる
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
